// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 884 ? "admin" : chunkId) + "." + {"539":"25c3ee3a","628":"2b0348bb","757":"392771f3","884":"97deb4e7"}[chunkId] + ".css";
};